// Stepper footer button text constants
export const STEPPER_BUTTON_TEXTS = {
  RESET_START_OVER: 'Reset & Start Over',
  RESET: 'Reset',
  SAVE_CHANGES: 'Save Changes',
  NEXT: 'Next',
  FINISH: 'Finish',
  BACK: 'Back',
  SKIP: 'Go to Save',
} as const;

export type StepperButtonText =
  (typeof STEPPER_BUTTON_TEXTS)[keyof typeof STEPPER_BUTTON_TEXTS];
